import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class ProductosView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "" };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != ""
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/productos/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <i><h3 className="pb-2" >General</h3></i>
                        <FormGroup className="col col-md-8">
                            <Label for="nombre">
                                <FormattedMessage id='Nombre' />
                            </Label>
                            <Input
                                id="nombre"
                                name="nombre"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.model.nombre}
                                valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                            />
                            <FormFeedback>
                                {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' /> }
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup className="col col-md-8">
                            <Label for="variedad">
                                <FormattedMessage id='Variedad' />
                            </Label>
                            <Input
                                id="variedad"
                                name="variedad"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.model.variedad}
                                valid={this.getValidationValue(this.state.modelValidation.variedad)}
                                invalid={!this.getValidationValue(this.state.modelValidation.variedad)}
                            />
                            <FormFeedback>
                                {this.state.model.variedad == '' ? <FormattedMessage id='Este campo es requerido' /> : "" }
                            </FormFeedback>
                        </FormGroup>
                        {/*<FormGroup className="col col-md-8">*/}
                        {/*    <Label for="label_1">*/}
                        {/*        <FormattedMessage id='Label' />{" 1"}*/}
                        {/*    </Label>*/}
                        {/*    <Input*/}
                        {/*        id="label_1"*/}
                        {/*        name="label_1"*/}
                        {/*        type="text"*/}
                        {/*        onChange={this.handleChange}*/}
                        {/*        value={this.state.model.label_1}*/}
                        {/*        valid={this.getValidationValue(this.state.modelValidation.label_1)}*/}
                        {/*        invalid={!this.getValidationValue(this.state.modelValidation.label_1)}*/}
                        {/*    />*/}
                        {/*    <FormFeedback>*/}
                        {/*        {this.state.model.label_1 == '' ? <FormattedMessage id='Este campo es requerido' /> : "" }*/}
                        {/*    </FormFeedback>*/}
                        {/*</FormGroup>*/}
                        <hr />
                        <i><h3 className="pb-2" >Varianti</h3></i>
                        <FormGroup className="col col-md-8">
                            <Label for="productCode">
                                <FormattedMessage id='ProductCode' />
                            </Label>
                            <Input
                                id="productCode"
                                name="productCode"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.model.productCode}
                                valid={this.getValidationValue(this.state.modelValidation.productCode)}
                                invalid={!this.getValidationValue(this.state.modelValidation.productCode)}
                            />
                            <FormFeedback>
                                {this.state.model.productCode == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup className="col col-md-8">
                            <Label for="productName">
                                <FormattedMessage id='ProductName' />
                            </Label>
                            <Input
                                id="productName"
                                name="productName"
                                type="text"
                                onChange={this.handleChange}
                                value={this.state.model.productName}
                                valid={this.getValidationValue(this.state.modelValidation.productName)}
                                invalid={!this.getValidationValue(this.state.modelValidation.productName)}
                            />
                            <FormFeedback>
                                {this.state.model.productName == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                    </Form>
                </Row>
            </div>
        );
    }

}